import { render, staticRenderFns } from "./ConventionSection.vue?vue&type=template&id=9bf57964"
import script from "./ConventionSection.vue?vue&type=script&lang=js"
export * from "./ConventionSection.vue?vue&type=script&lang=js"
import style0 from "./ConventionSection.vue?vue&type=style&index=0&id=9bf57964&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports